var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Panel',{attrs:{"icon":['fas', 'link'],"loading":_vm.loading,"loader-text":"Loading Ringba Integration Settings"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Ringba Integration ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"integration-settings"},[_c('ManageRingbaApiToken')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }